import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCountDown } from 'ahooks';
import React, { useEffect, useMemo } from 'react';
import { get } from 'lodash-es';
import { AhaaGoodsCard, FoodGoodsCard } from '../common/components';
import { useMobile } from '../common/hooks/use-mobile';
import { transformPageMargins } from '../common/utils';
import { classNames } from '../common/utils/classnames';
import { useDesignContext } from '../design-provider';
import ICON_ASLE_MORE from './images/icon-sale-more.png';
import ICON_DCH_ASLE_MORE from './images/icon-dch-sale-more.png';
import { getImageSrc } from '../common/utils/get-image-src';
import { RollContent } from './roll-product';
var Sale = function Sale(props) {
  var _a, _b, _c;
  var title = props.title,
    _props$setMethod = props.setMethod,
    setMethod = _props$setMethod === void 0 ? 1 : _props$setMethod,
    _props$time = props.time,
    time = _props$time === void 0 ? [] : _props$time,
    dataset = props.dataset,
    goodsGap = props.goodsGap,
    pagePadding = props.pagePadding,
    themeStyle = props.themeStyle,
    sales = props.sales,
    sale2 = props.sale2;
  var _useDesignContext = useDesignContext(),
    local = _useDesignContext.local;
  var displaySaleProducts = (get(dataset, 'products.data', []) || []).slice(0, 6);
  var mobile = useMobile();
  var _useDesignContext2 = useDesignContext(),
    designOnLink = _useDesignContext2.designOnLink;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    initialRenderComplete = _React$useState2[0],
    setInitialRenderComplete = _React$useState2[1];
  var _useCountDown = useCountDown({
      leftTime: setMethod === 1 ? (time[1] || +new Date((_b = (_a = displaySaleProducts[0]) === null || _a === void 0 ? void 0 : _a.seckillEndTime) === null || _b === void 0 ? void 0 : _b.replace(/-/g, '/'))) - Date.now() : Math.max(((_c = sale2.countdownEnds) !== null && _c !== void 0 ? _c : 0) - Date.now(), 0)
    }),
    _useCountDown2 = _slicedToArray(_useCountDown, 2),
    _useCountDown2$ = _useCountDown2[1],
    days = _useCountDown2$.days,
    hours = _useCountDown2$.hours,
    minutes = _useCountDown2$.minutes,
    seconds = _useCountDown2$.seconds;
  useEffect(function () {
    setInitialRenderComplete(true);
  }, []);
  function addCart(goods, count) {
    props.triggerRequest('addCart', {
      requestData: {
        csku: goods.csku,
        rsku: goods.rsku,
        count: count,
        goodsSpec: goods.goodsSpec,
        promotionId: goods.promotionId
      }
    });
  }
  /** 根据method获取path */
  var path = useMemo(function () {
    if (setMethod === 1) {
      return designOnLink({
        linkType: 'promotion',
        linkParams: sales.map(function (item) {
          return {
            id: item.id,
            name: item.discName
          };
        })
      });
    } else {
      return designOnLink(sale2.target);
    }
  }, [setMethod, sales, sale2]);
  // 暂时保留跳转逻辑
  // function link() {
  //     if (setMethod === 1) {
  //         props.triggerEvent('onLink', {
  //             linkType: 'promotion',
  //             linkParams: sales.map((item) => ({
  //                 id: item.id,
  //                 name: item.discName,
  //             })),
  //         });
  //     } else {
  //         props.triggerEvent('onLink', sale2.target);
  //     }
  // }
  function collect(goods, isFavorite) {
    return props.triggerRequest('collect', {
      requestData: {
        csku: goods.csku,
        isFavorite: isFavorite
      }
    });
  }
  // 暂时保留跳转逻辑
  // function linkDetail(goods: any) {
  //     props.triggerEvent('onLink', {
  //         linkType: 'product',
  //         linkParams: {
  //             name: goods.cskuName,
  //             id: goods.csku,
  //             csku: goods.csku,
  //         },
  //     });
  // }
  function renderBlock(value) {
    return _jsx("div", Object.assign({
      className: classNames('inline-flex items-center justify-center mx-0.5 w-6 h-4.5 text-xs rounded', 'cq-pc:mx-1 cq-pc:w-6 cq-pc:h-6 cq-pc:text-sm', {
        'bg-ahaa-red-1': themeStyle === 1,
        'bg-dch-red': themeStyle === 2
      })
    }, {
      children: _jsx("span", Object.assign({
        className: 'text-white'
      }, {
        children: String(value).padStart(2, '0')
      }))
    }));
  }
  var GoodsCardComponent = themeStyle === 1 ? AhaaGoodsCard : FoodGoodsCard;
  return _jsx("section", Object.assign({
    className: 'container'
  }, {
    children: _jsxs("div", Object.assign({
      className: classNames('w-full py-5', 'cq-pc:py-14'),
      style: {
        paddingLeft: transformPageMargins(pagePadding, mobile),
        paddingRight: transformPageMargins(pagePadding, mobile)
      }
    }, {
      children: [_jsxs("header", Object.assign({
        className: classNames('flex items-center pb-4', 'cq-pc:pb-8')
      }, {
        children: [_jsxs("div", Object.assign({
          className: 'flex-1 flex items-center overflow-x-hidden'
        }, {
          children: [title && _jsx("div", Object.assign({
            className: classNames('text-[18px] font-medium break-words text-ahaa-black-1 overflow-x-hidden', 'cq-pc:text-2xl')
          }, {
            children: title
          })), initialRenderComplete && _jsxs("div", Object.assign({
            className: classNames('flex-shrink-0 flex items-center px-1', 'cq-pc:px-3')
          }, {
            children: [days > 0 && _jsxs(_Fragment, {
              children: [renderBlock(days), local.sale.dayText]
            }), renderBlock(hours), " : ", renderBlock(minutes), " :", ' ', renderBlock(seconds)]
          }))]
        })), _jsxs("a", Object.assign({
          className: classNames('flex-shrink-0 flex items-center text-xs text-ahaa-black-2', 'cq-pc:text-sm'),
          href: path
        }, {
          children: [local.sale.viewMoreButtonText, themeStyle === 1 ? _jsx("img", {
            className: 'w-4 h-4',
            src: getImageSrc(ICON_ASLE_MORE)
          }) : _jsx("img", {
            className: 'w-4 h-4',
            src: getImageSrc(ICON_DCH_ASLE_MORE)
          })]
        }))]
      })), _jsx(RollContent, {
        GoodsCardComponent: GoodsCardComponent,
        displaySaleProducts: displaySaleProducts,
        addCart: addCart,
        collect: collect,
        goodsGap: goodsGap
      })]
    }))
  }));
};
export default Sale;